import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Baja from "../../Baja";
import { abrirPDF } from "../../../../utils/abrirPDF";

function CortesPendientesHabilitacion() {
  const { user } = useContext(AuthContext);
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let comp8 = new Date();
  comp8.setDate(comp8.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  let compromiso8 = moment(comp8).format("YYYY-MM-DD");

  const [procesos, setProcesos] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [maquileros, setMaquileros] = useState([]);
  const [selectedMaquilero, setSelectedMaquilero] = useState("");
  const [selectedVencido, setSelectedVencido] = useState("");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalNecesario, setTotalTotalNecesario] = useState(0);
  const [totalTotalRecibido, setTotalTotalRecibido] = useState(0);
  const [totalTotalPendiente, setTotalTotalPendiente] = useState(0);
  const [totalTotal, setTotalTotal] = useState(0);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [subtotal, setSubtotal] = useState();
  const [iva, setIva] = useState();
  const [descripcion, setDescripcion] = useState("");
  const [totalEdit, setTotalEdit] = useState();
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

useMemo(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(
      `${URL_CORTES}PendienteHabilitacion/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    )
    .then((response) => {
      const rows = response.data || [];

      const toNum = (v) => Number(v || 0);

      const arrayTabla = rows.map((r, idx) => ({
        _id: `${r.ORDEN_DE_PRODUCCION || ""}|${r.ARTICULO || ""}|${r.HABILITACION || ""}|${idx}`,

        orden: r.ORDEN_DE_PRODUCCION,
        articulo: r.ARTICULO,
        habilitacion: r.HABILITACION,

        piezas: toNum(r.PIEZAS),
        consumo: toNum(r.CONSUMO),
        necesario: toNum(r.NECESARIO),
        enviado: toNum(r.ENVIADO),
        faltante: toNum(r.FALTANTE),
      }));

      setComments(arrayTabla);
      setProcesos(arrayTabla); // o el state que uses para tu tabla
    })
    .catch((err) => console.log(err));
}, [selectedFechaInicio, selectedFechaFin]);


useEffect(() => {
axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMaquileros = response.data;
        setMaquileros(allMaquileros);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_CLIENTES}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allClientes = response.data;
      setClientes(allClientes);
    })
    .catch((err) => {
      console.log(err);
    });

     axios
    .get(`${URL_COLECCIONES}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allColecciones = response.data;
      setColecciones(allColecciones);
    })
    .catch((err) => {
      console.log(err);
    });
}, []);
  let total = 0;
  let totalTabla = 0;

  function PDFTabla() {
    total = 0;
    const data = procesos.map((c) => {
        total = total + c.cantidad;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total);
        return [
          c.orden,
          c.articulo,
          c.habilitacion,
          c.piezas,
          c.consumo,
          c.necesario,
          c.enviado,
          c.faltante
        ];
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text("Cortes Pendientes Habilitacion", 20, 25);
    doc.autoTable({
      head: [
        [
          "Orden",
          "Articulo",
          "Habilitacion",
          "Piezas",
          "Consumo",
          "Necesario",
          "Enviado",
          "Faltante",
        ],
      ],
      body: dataPDFLimpia,
      // startY: 45,
      // foot: [
      //   [
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     "Total",
      //     new Intl.NumberFormat("en-US").format(total),
      //     "",
      //   ],
      // ],
      showFoot: "lastPage",
    });
    abrirPDF(doc);
  }

  function excel() {
    const dataExcel = procesos.map((c) => {
      // if (
      //   (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
      //   (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) 
      // ) {
        return {
          Orden: c.orden,
          Articulo: c.articulo,
          Habilitacion: c.habilitacion,
          Piezas: c.piezas,
          Consumo: c.consumo,
          Necesario: c.necesario,
          Enviado: c.enviado,
          Faltante: c.faltante,
        };
      // }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `ProcesosCorte-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `ProcesosCorte`,
        sheetFilter: [
          "Orden",
          "Articulo",
          "Habilitacion",
          "Piezas",
          "Consumo",
          "Necesario",
          "Enviado",
          "Faltante",
        ],
        sheetHeader: [
          "Orden",
          "Articulo",
          "Habilitacion",
          "Piezas",
          "Consumo",
          "Necesario",
          "Enviado",
          "Faltante",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    total = 0;
    const data = procesos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedMaquilero == 0 || selectedMaquilero == c.idMaquilero)&&
        (selectedCliente == 0 || selectedCliente == c.idCliente)&&
        (selectedColeccion == 0 || selectedColeccion == c.idColeccion)
      ) {
        total = total + c.cantidad;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total);
        return [
          c.fecha,
          c.maquilero,
          c.cliente,
          c.proceso,
          c.articulo,
          c.coleccion,
          c.fechaCompromiso,
          c.corte,
          c.pedidoCliente,
          c.cantidad,
          c.recibido,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text("Cortes Pendientes Habilitacion", 20, 25);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Maquilero",
          "Cliente",
          "Proceso",
          "Articulo",
          "Coleccion",
          "Fecha Comp.",
          "Corte",
          "Pedido Cliente",
          "Cantidad",
          "Recibido",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

const headers = [
  { name: "Orden", field: "orden", sortable: true },
  { name: "Artículo", field: "articulo", sortable: true },
  { name: "Habilitación", field: "habilitacion", sortable: true },
  { name: "Piezas", field: "piezas", sortable: true },
  { name: "Consumo", field: "consumo", sortable: true },
  { name: "Necesario", field: "necesario", sortable: true },
  { name: "Enviado", field: "enviado", sortable: true },
  { name: "Faltante", field: "faltante", sortable: true },
];


const commentsData = useMemo(() => {
  let computedComments = [...(comments || [])];

  const safeStr = (v) => (v == null ? "" : String(v));
  const safeLower = (v) => safeStr(v).toLowerCase();
  const toNum = (v) => Number(v || 0);

  // =========================
  // SEARCH
  // =========================
  if (search) {
    const s = search.toLowerCase();

    computedComments = computedComments.filter((c) => {
      return (
        safeLower(c.orden).includes(s) ||
        safeLower(c.articulo).includes(s) ||
        safeLower(c.habilitacion).includes(s) ||
        safeStr(c.piezas).includes(search) ||
        safeStr(c.consumo).includes(search) ||
        safeStr(c.necesario).includes(search) ||
        safeStr(c.enviado).includes(search) ||
        safeStr(c.faltante).includes(search)
      );
    });
  }

  // =========================
  // TOTAL ITEMS + TOTALES
  // =========================
  setTotalItems(computedComments.length);

  const sumField = (field) =>
    computedComments.reduce((acc, c) => acc + toNum(c[field]), 0);

  setTotalTotalCantidad(sumField("piezas"));     // si quieres reusar tus states
  setTotalTotalNecesario(sumField("necesario"));     // si quieres reusar tus states
  setTotalTotalRecibido(sumField("enviado"));    // enviado
  setTotalTotalPendiente(sumField("faltante"));  // faltante
  // si tienes un total monetario ya no aplica, ponlo en 0 o quítalo
  setTotalTotal(0);

  // =========================
  // SORTING
  // =========================
  if (sorting?.field) {
    const field = sorting.field;
    const isNumber = ["piezas", "consumo", "necesario", "enviado", "faltante"].includes(field);
    const reversed = sorting.order === "asc" ? 1 : -1;

    if (isNumber) {
      computedComments.sort((a, b) => reversed * (toNum(a[field]) - toNum(b[field])));
    } else {
      computedComments.sort((a, b) =>
        reversed * safeStr(a[field]).localeCompare(safeStr(b[field]))
      );
    }
  }

  // =========================
  // PAGINATION
  // =========================
  return computedComments.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
  );
}, [comments, currentPage, search, sorting]);


  function jalaInfo(id, subtotal, iva, total, concepto, descripcion, fecha) {
    setIdEdit(id);
    setSubtotal(subtotal);
    setIva(iva);
    setTotalEdit(total);
    setSelectedConcepto(concepto);
    setDescripcion(descripcion);
    setFecha(fecha);
    toggleEdit();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuProduccion"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>Enviar Lista de Gastos</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      Enviar
                    </Button>
                  </ModalFooter>
                </Modal>
                <br />
                <h3 align="center">Cortes Pendientes Habilitacion</h3>
                <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                  {/* <Col md={2}>
                    <Label>Maquilero</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedMaquilero}
                      onChange={(e) => {
                        setSelectedMaquilero(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {maquileros
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Cliente</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Coleccion</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedColeccion}
                      onChange={(e) => {
                        setSelectedColeccion(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colecciones
                        .sort((a, b) =>
                          a.name > b.name ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.name}</option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Label>Vencimiento</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedVencido}
                      onChange={(e) => {
                        setSelectedVencido(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="vencido">Vencido</option>
                      <option value="porVencer">Proximo a Venceer</option>
                      <option value="aTiempo">A tiempo</option>
                    </Input>
                  </Col> */}
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl table-dark-header"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

<tbody>
  {commentsData.map((c) => {
    // opcional: colorear por faltante
    const rowStyle =
      Number(c.faltante || 0) > 0 ? { backgroundColor: "#ffe5e5" } : {};

    return (
      // <tr key={c._id} style={rowStyle}>
      <tr key={c._id}>
        <td>{c.orden}</td>
        <td>{c.articulo}</td>
        <td>{c.habilitacion}</td>

        <td>
          {new Intl.NumberFormat("en-US").format(c.piezas)}
        </td>
        <td>
          {new Intl.NumberFormat("en-US").format(c.consumo)}
        </td>
        <td>
          {new Intl.NumberFormat("en-US").format(c.necesario)}
        </td>
        <td>
          {new Intl.NumberFormat("en-US").format(c.enviado)}
        </td>
        <td style={{fontWeight: "bold" }}>
          {new Intl.NumberFormat("en-US").format(c.faltante)}
        </td>
      </tr>
    );
  })}

  {/* TOTAL */}
  <tr>
    <td></td>
    <td></td>
    <td className="negrita" align="center">
      TOTAL
    </td>

    <td className="negrita">
      {new Intl.NumberFormat("en-US").format(totalTotalCantidad)} {/* piezas */}
    </td>
    <td></td>
    <td className="negrita">
      {new Intl.NumberFormat("en-US").format(totalTotalNecesario || 0)}
    </td>
    <td className="negrita">
      {new Intl.NumberFormat("en-US").format(totalTotalRecibido)} {/* enviado */}
    </td>
    <td className="negrita">
      {new Intl.NumberFormat("en-US").format(totalTotalPendiente)} {/* faltante */}
    </td>
  </tr>
</tbody>

                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default CortesPendientesHabilitacion;
